interface Option {
  value: string;
  label: string;
}

export const timeOptions: Option[] = [
  { value: 'all', label: '全部时间' },
  { value: '7', label: '近 7 天' },
  { value: '30', label: '近 30 天' },
  { value: '365', label: '近一年' },
];

export const durationOptions: Option[] = [
  { value: 'all', label: '全部时长' },
  { value: 'short', label: '5 分钟以内' },
  { value: 'medium', label: '5 - 20 分钟' },
  { value: 'long', label: '20 分钟以上' },
];

export const sortOptions: Option[] = [
  { value: 'latest', label: '最新' },
  { value: 'popular', label: '最热' },
  { value: 'duration', label: '时长' },
];

interface SegmentedProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  icon?: string;
}

export function Segmented({ options, value, onChange, icon }: SegmentedProps) {
  return (
    <div className="flex items-center gap-2 min-w-0">
      {icon && (
        <span className="hidden sm:flex items-center justify-center w-6 h-6 text-foreground-500 shrink-0">
          <i className={icon}></i>
        </span>
      )}
      <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 overflow-x-auto no-scrollbar">
        {options.map((o) => (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
              value === o.value
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

interface FilterBarProps {
  subCategories: Option[];
  subCategory: string;
  onSubCategory: (value: string) => void;
  time: string;
  onTime: (value: string) => void;
  duration: string;
  onDuration: (value: string) => void;
  sort: string;
  onSort: (value: string) => void;
}

export default function FilterBar({
  subCategories,
  subCategory,
  onSubCategory,
  time,
  onTime,
  duration,
  onDuration,
  sort,
  onSort,
}: FilterBarProps) {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-3">
        <Segmented
          options={[{ value: 'all', label: '全部类型' }, ...subCategories]}
          value={subCategory}
          onChange={onSubCategory}
          icon="ri-price-tag-3-line"
        />
        <Segmented options={timeOptions} value={time} onChange={onTime} icon="ri-calendar-line" />
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Segmented options={durationOptions} value={duration} onChange={onDuration} icon="ri-timer-line" />
        <Segmented options={sortOptions} value={sort} onChange={onSort} icon="ri-sort-desc" />
      </div>
    </div>
  );
}